import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-gallery-camera',
  templateUrl: './gallery-camera.page.html',
  styleUrls: ['./gallery-camera.page.scss'],
})
export class GalleryCameraPage implements OnInit {
  isIos: any;
  isAndroid: any;
  constructor(
    public modalCtrl: ModalController,
    public addCall: AddCall,
    public platform: Platform,
  ) { }

  ngOnInit() {
    console.log("ios")
  }
  ionViewWillEnter() {
    if (this.platform.is("ios")) {
      console.log("ios")
      this.isIos = 1
    } else if (this.platform.is("android")) {
      this.isAndroid = 1
    }
  }
  dismiss() {
    this.modalCtrl.dismiss();
  }

  camerOpens(type: any, event: any) {
    this.modalCtrl.dismiss({ From: type, To: event });
  }
}
